import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 24,
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m22 20v2h-20v-2zm-10-19a1 1 0 0 1 1 1v11.585l2.293-2.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-4 4a1.006 1.006 0 0 1 -.707.293l.085-.004a1.006 1.006 0 0 1 -.052.003l-.033.001a1.018 1.018 0 0 1 -.52-.146 1.035 1.035 0 0 1 -.187-.147l.09.08a1.006 1.006 0 0 1 -.09-.08l-4-4a1 1 0 0 1 1.414-1.414l2.293 2.292v-11.585a1 1 0 0 1 .883-.993z" })
});
export default SvgDownload;
